import React from 'react'

const Logo = ( ) => {
 
    return (
        <div id="logo">
          <h1>This is the Logo section</h1>
         

        </div>
    
         
    
  )
}
 
export default Logo;